import { render, staticRenderFns } from "./checkin_kiosk_hub_component.vue?vue&type=template&id=51a40482&scoped=true"
import script from "./checkin_kiosk_hub_component.vue?vue&type=script&lang=js"
export * from "./checkin_kiosk_hub_component.vue?vue&type=script&lang=js"
import style0 from "./checkin_kiosk_hub_component.vue?vue&type=style&index=0&id=51a40482&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a40482",
  null
  
)

export default component.exports